export enum SuppliesSubscriptionStatus {
  Active = "active",
  Paused = "paused",
  Canceled = "canceled",
}
